import React, { useState } from "react";
import { Tooltip, Button } from "reactstrap";

function TreeDocNode({
  path,
  node,
  clickedFolder,
  downloadDocument,
  activeFolder,
  sendDataToTreeDoc,
}) {
  const { children, document_name, document_uuid } = node;
  const handleClick = () => {
    handleFolderClick(node);
  };

  const handleFolderClick = async (data) => {
    clickedFolder(data);
  };

  const downloadDocumentClick = () => {
    downloadDocument(node);
  };

  const checked = () => {
    sendDataToTreeDoc(node);
  };

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [detailUuid, setDetailUuid] = useState(null);

  const [selected, setSelected] = useState(false);

  const toggleTooltip = () => {
    setTooltipOpen((prevTooltipOpen) => !prevTooltipOpen);
  };
  return (
    <>
      <div style={{ marginBottom: "10px", cursor: "pointer" }}>
        <span
          style={{
            fontWeight: activeFolder == document_uuid ? "bold" : "normal",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <Button
            title="Download"
            className="btn btn-success btn-sm"
            id={"detail-" + document_uuid}
            onClick={() => {
              setDetailUuid(document_uuid);
              toggleTooltip();
            }}
            style={{
              marginRight: "2px",
              padding: "2px 5px",
            }}
          >
            <i
              onClick={downloadDocumentClick}
              className="bx bxs-download"
              style={{ color: "#FF00000" }}
            ></i>{" "}
          </Button> */}
          {/* <Button
            title="Select"
            className="btn btn-warning btn-sm"
            id={"detail-" + document_uuid}
            onClick={() => {
              setDetailUuid(document_uuid);
              toggleTooltip();
            }}
            style={{
              marginRight: "2px",
              padding: "2px 5px",
            }}
          >
            <i
              onClick={handleClick}
              className="bx bx-select-multiple"
              style={{ color: "#FF00000" }}
            ></i>{" "}
          </Button>{" "} */}
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="radioOptions"
              id="radioOption1"
              value="option1"
              // checked={selectedOption === "option1"}
              onChange={checked}
            />
            <label
              className="col-md-3 col-form-label"
              onClick={downloadDocumentClick}
            >
              {document_name}{" "}
            </label>
          </div>
        </span>
      </div>
    </>
  );
}

export default TreeDocNode;
